import Chatbox from "./Chatbox";

export default Chatbox;
